import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { Observable } from 'rxjs';

import { User } from './../../common/models/user';
import { Member } from '../../common/models/member';

import { environment } from './../../../environments/environment';
import { SessionManager } from '../../common/helpers/session-manager';


@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    // Include it under 'imports' in your application module  // after BrowserModule.
  ],
})

@Injectable()
export class AccountService {
  private emblanoUrl = environment.emblanoUrl;
  private host = environment.host;
  public token: string;

  constructor(private http: Http, private sessionManager: SessionManager) { }


  register(newMember: Member): Observable<any> {
    const registerUrl = this.host + '/api/account/register';

    const registerModel = JSON.stringify(newMember);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    const options = new RequestOptions({ headers: headers, withCredentials: true });

    return this.http.post(registerUrl, registerModel, options)
      .map((response: any) => {


        console.log("-------------------------------");
        console.log(response.json());
        const customer = response.json();

        const user = new User();
        user.firstName = customer.firstName;
        user.lastName = customer.lastName;
        user.email = customer.emailAddress;
        user.id = customer.customerID;
        user.isMemberExpired = customer.isMemberExpired;
        this.sessionManager.setCurrentUser(user);

        return response;
      });
  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/authentication/services/account.service.ts